/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, List } from 'immutable';

const addStat = (state, from, to, timeTaken) => {
  const pathName = `${from}->${to}`;
  return state.has(pathName) ? state.set(pathName, state.get(pathName).push(timeTaken)) :
    state.set(pathName, List.of(timeTaken));
};


export const userMetricsReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'ADD_NEW_STAT':
      return addStat(state, action.from, action.to, action.timeTaken);
    case 'CLEAR_STATS':
      return state.clear();
    default:
      return state;
  }
};

let previousDate = new Date().getTime();
export const addUsage = (dispatch, from, to) => {
  const newDate = new Date().getTime();
  const timeTaken = newDate - previousDate;
  previousDate = newDate;
  dispatch({ type: 'ADD_NEW_STAT', from, to, timeTaken });
  return true;
};
export const clearStats = (dispatch) => {
  previousDate = new Date().getTime();
  dispatch({ type: 'CLEAR_STATS' });
};
